import React, { useState } from 'react';
import { addTransversalDocument } from '../../services/sBook/document.service';
import Loading from '../../components/Templates/Site/Loading';
import { SpinnerSize, TooltipHost } from '@fluentui/react';
import { t } from 'i18next';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../services/Env/transversal.service';

const DocumentUploader = ({ticket_id,ticket_answer_id, handleRefreshDocs}) => {

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploadInProgress, setUploadInProgress] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };  

  const handleUpload = async () => {
    setUploadInProgress(true);

    if (!selectedFile) {
      alert('Seleccione un archivo para cargar');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      if(ticket_answer_id) {
          //formData.append("id", ticket_answer_id);
          //formData.append("url", 'ticket/ticketAnswerDocumentadd');
          //const response = await addTransversalDocument(formData);

          await envDocumentGetUrl('ticket/ticketAnswerDocumentadd', ticket_answer_id, selectedFile.name).then(async (responseGetUrl) => {
              if (responseGetUrl.data.succeeded === true) {
                  await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                      if (responseAzure.data === "" && responseAzure.status === 201) {
                            await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                if (responseValidate.data.succeeded === true) {
                                    if (responseValidate.data.data.result_validate === true) {
                                        setUploadInProgress(false);
                                        handleRefreshDocs();
                                        setUploadStatus('Documento cargado exitosamente');
                                    }
                                    else {
                                        setUploadStatus(t(responseValidate.data.data.result_validate_msg));
                                        setUploadInProgress(false)
                                    }
                                }
                                else {
                                    setUploadStatus(t(responseValidate.data.message));
                                    setUploadInProgress(false);
                                }
                            })
                            .catch((error) => {
                                setUploadStatus(t('data-lang-msg-operationerror'));
                                setUploadInProgress(false);
                            });
                      }
                      else {
                          setUploadStatus(t('data-lang-msg-operationerror'));
                          setUploadInProgress(false);
                      }
                  })
                  .catch(async (error) => {
                    await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                        setUploadStatus(t('data-lang-msg-operationerror'));
                        setUploadInProgress(false);
                    })
                    .catch((error) => {
                        setUploadStatus(t('data-lang-msg-operationerror'));
                        setUploadInProgress(false);
                    });
                  });
              } else {
                  setUploadStatus(t(responseGetUrl.data.message));
                  setUploadInProgress(false);
              }
              setSelectedFile(null);
              setUploadInProgress(false);
          })
          .catch(() => {
                setUploadStatus(t('data-lang-msg-operationerror'));
                setUploadInProgress(false);
          });
      }
      else {
          //formData.append("id", ticket_id);
          //formData.append("url", 'ticket/ticketDocumentadd');
          //const response = await addTransversalDocument(formData);

          await envDocumentGetUrl('ticket/ticketDocumentadd', ticket_id, selectedFile.name).then(async (responseGetUrl) => {
              if (responseGetUrl.data.succeeded === true) {
                  await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                      if (responseAzure.data === "" && responseAzure.status === 201) {
                          await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                              if (responseValidate.data.succeeded === true) {
                                  if (responseValidate.data.data.result_validate === true) {
                                      setUploadInProgress(false);
                                      handleRefreshDocs();
                                      setUploadStatus('Documento cargado exitosamente');
                                  }
                                  else {
                                      setUploadStatus(t(responseValidate.data.data.result_validate_msg));
                                      setUploadInProgress(false)
                                  }
                              }
                              else {
                                  setUploadStatus(t('data-lang-msg-operationerror'));
                                  setUploadInProgress(false);
                              }
                          });
                      }
                      else {
                          setUploadStatus(t('data-lang-msg-operationerror'));
                          setUploadInProgress(false);
                      }
                  })
                  .catch((error) => {
                      setUploadStatus(t('data-lang-msg-operationerror'));
                      setUploadInProgress(false);
                  });
              } else {
                  setUploadStatus(t('data-lang-msg-operationerror'));
                  setUploadInProgress(false);
              }
              setSelectedFile(null);
              setUploadInProgress(false);
          })
          .catch(() => {
              setUploadStatus(t('data-lang-msg-operationerror'));
              setUploadInProgress(false);
          });
      }
    } catch (error) {
      console.error('Error al cargar el documento:', error);
      setUploadStatus('Error al cargar el documento');
    }
  };

  return (
    <div>
      <TooltipHost content={
          <>
              <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
              <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
          </>
      }>
        <input type="file" onChange={handleFileChange} />
      </TooltipHost>
      <div className='d-flex'>
        <button onClick={handleUpload}>Cargar Documento</button>
        {
            uploadInProgress &&
            <Loading
                    inputParam_ShowLoading={true}
                    inputParam_ShowText={false}
                    inputParam_Width={'35px'}
                    inputParam_Height={'35px'}
                    inputParam_Left={""}
                    inputParam_Style={{marginTop: 0}}
                    inputParam_ColClassName={"me-2"}
                    inputParam_MarginLeft={"auto"}
                    inputParam_SpinnerSize={SpinnerSize.medium} />
        }
      </div>
      {uploadStatus && <p>{uploadStatus}</p>}
    </div>
  );
};

export default DocumentUploader;
